export default __webpack_public_path__ + "5375c6b8541d656bcdf7d71c6928989c.png";